import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { I18nextProvider } from 'react-i18next';

import App from './app';
import { store } from './redux/store';
import 'react-toastify/dist/ReactToastify.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import i18n from '../i18n';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

const queryClient = new QueryClient();

// Wait for i18n to initialize

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <I18nextProvider i18n={i18n}>
        <ToastContainer theme="colored" position="top-center" autoClose={2000} />
        <Suspense>
          <Provider store={store}>
            <QueryClientProvider client={queryClient}>
              <ReactQueryDevtools initialIsOpen={false} />
              <App />
            </QueryClientProvider>
          </Provider>
        </Suspense>
      </I18nextProvider>
    </BrowserRouter>
  </HelmetProvider>
);
